import { ReactNode, useEffect } from 'react';
import './BasePageComponent.css';

interface BasePageComponentProps {
  id: string;
  title: string;
  description?: string;
  children: ReactNode;
}

const BasePageComponent = ({
  id,
  title,
  description,
  children,
}: BasePageComponentProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="base-page-container" id={id}>
      <div className="base-page-content">
        <h1 className="page-title">{title}</h1>
        {description && <p className="page-description">{description}</p>}
        {children}
      </div>
    </div>
  );
};

export default BasePageComponent; 